( function ( $, undefined ) {
	acf.jsxNameReplacements = {
		'accent-height': 'accentHeight',
		accentheight: 'accentHeight',
		'accept-charset': 'acceptCharset',
		acceptcharset: 'acceptCharset',
		accesskey: 'accessKey',
		'alignment-baseline': 'alignmentBaseline',
		alignmentbaseline: 'alignmentBaseline',
		allowedblocks: 'allowedBlocks',
		allowfullscreen: 'allowFullScreen',
		allowreorder: 'allowReorder',
		'arabic-form': 'arabicForm',
		arabicform: 'arabicForm',
		attributename: 'attributeName',
		attributetype: 'attributeType',
		autocapitalize: 'autoCapitalize',
		autocomplete: 'autoComplete',
		autocorrect: 'autoCorrect',
		autofocus: 'autoFocus',
		autoplay: 'autoPlay',
		autoreverse: 'autoReverse',
		autosave: 'autoSave',
		basefrequency: 'baseFrequency',
		'baseline-shift': 'baselineShift',
		baselineshift: 'baselineShift',
		baseprofile: 'baseProfile',
		calcmode: 'calcMode',
		'cap-height': 'capHeight',
		capheight: 'capHeight',
		cellpadding: 'cellPadding',
		cellspacing: 'cellSpacing',
		charset: 'charSet',
		class: 'className',
		classid: 'classID',
		classname: 'className',
		'clip-path': 'clipPath',
		'clip-rule': 'clipRule',
		clippath: 'clipPath',
		clippathunits: 'clipPathUnits',
		cliprule: 'clipRule',
		'color-interpolation': 'colorInterpolation',
		'color-interpolation-filters': 'colorInterpolationFilters',
		'color-profile': 'colorProfile',
		'color-rendering': 'colorRendering',
		colorinterpolation: 'colorInterpolation',
		colorinterpolationfilters: 'colorInterpolationFilters',
		colorprofile: 'colorProfile',
		colorrendering: 'colorRendering',
		colspan: 'colSpan',
		contenteditable: 'contentEditable',
		contentscripttype: 'contentScriptType',
		contentstyletype: 'contentStyleType',
		contextmenu: 'contextMenu',
		controlslist: 'controlsList',
		crossorigin: 'crossOrigin',
		dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
		datetime: 'dateTime',
		defaultchecked: 'defaultChecked',
		defaultvalue: 'defaultValue',
		diffuseconstant: 'diffuseConstant',
		disablepictureinpicture: 'disablePictureInPicture',
		disableremoteplayback: 'disableRemotePlayback',
		'dominant-baseline': 'dominantBaseline',
		dominantbaseline: 'dominantBaseline',
		edgemode: 'edgeMode',
		'enable-background': 'enableBackground',
		enablebackground: 'enableBackground',
		enctype: 'encType',
		enterkeyhint: 'enterKeyHint',
		externalresourcesrequired: 'externalResourcesRequired',
		'fill-opacity': 'fillOpacity',
		'fill-rule': 'fillRule',
		fillopacity: 'fillOpacity',
		fillrule: 'fillRule',
		filterres: 'filterRes',
		filterunits: 'filterUnits',
		'flood-color': 'floodColor',
		'flood-opacity': 'floodOpacity',
		floodcolor: 'floodColor',
		floodopacity: 'floodOpacity',
		'font-family': 'fontFamily',
		'font-size': 'fontSize',
		'font-size-adjust': 'fontSizeAdjust',
		'font-stretch': 'fontStretch',
		'font-style': 'fontStyle',
		'font-variant': 'fontVariant',
		'font-weight': 'fontWeight',
		fontfamily: 'fontFamily',
		fontsize: 'fontSize',
		fontsizeadjust: 'fontSizeAdjust',
		fontstretch: 'fontStretch',
		fontstyle: 'fontStyle',
		fontvariant: 'fontVariant',
		fontweight: 'fontWeight',
		for: 'htmlFor',
		foreignobject: 'foreignObject',
		formaction: 'formAction',
		formenctype: 'formEncType',
		formmethod: 'formMethod',
		formnovalidate: 'formNoValidate',
		formtarget: 'formTarget',
		frameborder: 'frameBorder',
		'glyph-name': 'glyphName',
		'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
		'glyph-orientation-vertical': 'glyphOrientationVertical',
		glyphname: 'glyphName',
		glyphorientationhorizontal: 'glyphOrientationHorizontal',
		glyphorientationvertical: 'glyphOrientationVertical',
		glyphref: 'glyphRef',
		gradienttransform: 'gradientTransform',
		gradientunits: 'gradientUnits',
		'horiz-adv-x': 'horizAdvX',
		'horiz-origin-x': 'horizOriginX',
		horizadvx: 'horizAdvX',
		horizoriginx: 'horizOriginX',
		hreflang: 'hrefLang',
		htmlfor: 'htmlFor',
		'http-equiv': 'httpEquiv',
		httpequiv: 'httpEquiv',
		'image-rendering': 'imageRendering',
		imagerendering: 'imageRendering',
		innerhtml: 'innerHTML',
		inputmode: 'inputMode',
		itemid: 'itemID',
		itemprop: 'itemProp',
		itemref: 'itemRef',
		itemscope: 'itemScope',
		itemtype: 'itemType',
		kernelmatrix: 'kernelMatrix',
		kernelunitlength: 'kernelUnitLength',
		keyparams: 'keyParams',
		keypoints: 'keyPoints',
		keysplines: 'keySplines',
		keytimes: 'keyTimes',
		keytype: 'keyType',
		lengthadjust: 'lengthAdjust',
		'letter-spacing': 'letterSpacing',
		letterspacing: 'letterSpacing',
		'lighting-color': 'lightingColor',
		lightingcolor: 'lightingColor',
		limitingconeangle: 'limitingConeAngle',
		marginheight: 'marginHeight',
		marginwidth: 'marginWidth',
		'marker-end': 'markerEnd',
		'marker-mid': 'markerMid',
		'marker-start': 'markerStart',
		markerend: 'markerEnd',
		markerheight: 'markerHeight',
		markermid: 'markerMid',
		markerstart: 'markerStart',
		markerunits: 'markerUnits',
		markerwidth: 'markerWidth',
		maskcontentunits: 'maskContentUnits',
		maskunits: 'maskUnits',
		maxlength: 'maxLength',
		mediagroup: 'mediaGroup',
		minlength: 'minLength',
		nomodule: 'noModule',
		novalidate: 'noValidate',
		numoctaves: 'numOctaves',
		'overline-position': 'overlinePosition',
		'overline-thickness': 'overlineThickness',
		overlineposition: 'overlinePosition',
		overlinethickness: 'overlineThickness',
		'paint-order': 'paintOrder',
		paintorder: 'paintOrder',
		'panose-1': 'panose1',
		pathlength: 'pathLength',
		patterncontentunits: 'patternContentUnits',
		patterntransform: 'patternTransform',
		patternunits: 'patternUnits',
		playsinline: 'playsInline',
		'pointer-events': 'pointerEvents',
		pointerevents: 'pointerEvents',
		pointsatx: 'pointsAtX',
		pointsaty: 'pointsAtY',
		pointsatz: 'pointsAtZ',
		preservealpha: 'preserveAlpha',
		preserveaspectratio: 'preserveAspectRatio',
		primitiveunits: 'primitiveUnits',
		radiogroup: 'radioGroup',
		readonly: 'readOnly',
		referrerpolicy: 'referrerPolicy',
		refx: 'refX',
		refy: 'refY',
		'rendering-intent': 'renderingIntent',
		renderingintent: 'renderingIntent',
		repeatcount: 'repeatCount',
		repeatdur: 'repeatDur',
		requiredextensions: 'requiredExtensions',
		requiredfeatures: 'requiredFeatures',
		rowspan: 'rowSpan',
		'shape-rendering': 'shapeRendering',
		shaperendering: 'shapeRendering',
		specularconstant: 'specularConstant',
		specularexponent: 'specularExponent',
		spellcheck: 'spellCheck',
		spreadmethod: 'spreadMethod',
		srcdoc: 'srcDoc',
		srclang: 'srcLang',
		srcset: 'srcSet',
		startoffset: 'startOffset',
		stddeviation: 'stdDeviation',
		stitchtiles: 'stitchTiles',
		'stop-color': 'stopColor',
		'stop-opacity': 'stopOpacity',
		stopcolor: 'stopColor',
		stopopacity: 'stopOpacity',
		'strikethrough-position': 'strikethroughPosition',
		'strikethrough-thickness': 'strikethroughThickness',
		strikethroughposition: 'strikethroughPosition',
		strikethroughthickness: 'strikethroughThickness',
		'stroke-dasharray': 'strokeDasharray',
		'stroke-dashoffset': 'strokeDashoffset',
		'stroke-linecap': 'strokeLinecap',
		'stroke-linejoin': 'strokeLinejoin',
		'stroke-miterlimit': 'strokeMiterlimit',
		'stroke-opacity': 'strokeOpacity',
		'stroke-width': 'strokeWidth',
		strokedasharray: 'strokeDasharray',
		strokedashoffset: 'strokeDashoffset',
		strokelinecap: 'strokeLinecap',
		strokelinejoin: 'strokeLinejoin',
		strokemiterlimit: 'strokeMiterlimit',
		strokeopacity: 'strokeOpacity',
		strokewidth: 'strokeWidth',
		suppresscontenteditablewarning: 'suppressContentEditableWarning',
		suppresshydrationwarning: 'suppressHydrationWarning',
		surfacescale: 'surfaceScale',
		systemlanguage: 'systemLanguage',
		tabindex: 'tabIndex',
		tablevalues: 'tableValues',
		targetx: 'targetX',
		targety: 'targetY',
		templatelock: 'templateLock',
		'text-anchor': 'textAnchor',
		'text-decoration': 'textDecoration',
		'text-rendering': 'textRendering',
		textanchor: 'textAnchor',
		textdecoration: 'textDecoration',
		textlength: 'textLength',
		textrendering: 'textRendering',
		'underline-position': 'underlinePosition',
		'underline-thickness': 'underlineThickness',
		underlineposition: 'underlinePosition',
		underlinethickness: 'underlineThickness',
		'unicode-bidi': 'unicodeBidi',
		'unicode-range': 'unicodeRange',
		unicodebidi: 'unicodeBidi',
		unicoderange: 'unicodeRange',
		'units-per-em': 'unitsPerEm',
		unitsperem: 'unitsPerEm',
		usemap: 'useMap',
		'v-alphabetic': 'vAlphabetic',
		'v-hanging': 'vHanging',
		'v-ideographic': 'vIdeographic',
		'v-mathematical': 'vMathematical',
		valphabetic: 'vAlphabetic',
		'vector-effect': 'vectorEffect',
		vectoreffect: 'vectorEffect',
		'vert-adv-y': 'vertAdvY',
		'vert-origin-x': 'vertOriginX',
		'vert-origin-y': 'vertOriginY',
		vertadvy: 'vertAdvY',
		vertoriginx: 'vertOriginX',
		vertoriginy: 'vertOriginY',
		vhanging: 'vHanging',
		videographic: 'vIdeographic',
		viewbox: 'viewBox',
		viewtarget: 'viewTarget',
		vmathematical: 'vMathematical',
		'word-spacing': 'wordSpacing',
		wordspacing: 'wordSpacing',
		'writing-mode': 'writingMode',
		writingmode: 'writingMode',
		'x-height': 'xHeight',
		xchannelselector: 'xChannelSelector',
		xheight: 'xHeight',
		'xlink:actuate': 'xlinkActuate',
		'xlink:arcrole': 'xlinkArcrole',
		'xlink:href': 'xlinkHref',
		'xlink:role': 'xlinkRole',
		'xlink:show': 'xlinkShow',
		'xlink:title': 'xlinkTitle',
		'xlink:type': 'xlinkType',
		xlinkactuate: 'xlinkActuate',
		xlinkarcrole: 'xlinkArcrole',
		xlinkhref: 'xlinkHref',
		xlinkrole: 'xlinkRole',
		xlinkshow: 'xlinkShow',
		xlinktitle: 'xlinkTitle',
		xlinktype: 'xlinkType',
		'xml:base': 'xmlBase',
		'xml:lang': 'xmlLang',
		'xml:space': 'xmlSpace',
		xmlbase: 'xmlBase',
		xmllang: 'xmlLang',
		'xmlns:xlink': 'xmlnsXlink',
		xmlnsxlink: 'xmlnsXlink',
		xmlspace: 'xmlSpace',
		ychannelselector: 'yChannelSelector',
		zoomandpan: 'zoomAndPan',
	};
} )( jQuery );
